import { useFetch } from 'app/queryProvider';
import { TTeleassistanceRequest } from 'app/_modules/pathways';

export const useTeleassistanceDetail = (id: string) => {
    const { data, isFetching } = useFetch<TTeleassistanceRequest>({
        queryKey: [['appointments', id]],
        url: `/${id}`,
        resource: { name: 'appointments' },
        options: { enabled: !!id },
    });

    return { detail: data ?? null, isFetching };
};
